import script from "./checkinRewards.vue?vue&type=script&setup=true&lang=ts"
export * from "./checkinRewards.vue?vue&type=script&setup=true&lang=ts"

import "./checkinRewards.vue?vue&type=style&index=0&id=fcce806c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcce806c"]])

export default __exports__